export default __webpack_public_path__ + "21dcce41025364d8debff9893ac99b27.png";